<template>
  <transition name="slide">
    <div class="userModal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="content">
          <div class="leafL"></div><div class="leafR"></div>
          <div class="ball"></div><div class="payungB"></div>
          <div class="rumputL"></div><div class="rumputR"></div>
          <div class="tideBg"></div>
          <div class="searchCnt fieldGroup">
            <input type="text" placeholder="Find answer..." class="field"
              v-on:input="search" v-model="q">
            <div class="searchIcon"></div>
          </div>
          <div class="loadingFaq" v-if="loading"></div>
          <div class="faqCnt" v-else>
            <div class="faqItem" v-for="(f, i) in faq" :key="i">
              <h4>{{f.q}}</h4>
              <p>{{f.a}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      faq: [],
      allFaq: [],
      q: '',
      loading: true,
    };
  },
  computed: {},
  methods: {
    open(d, n) {
      this.show = true;
      if (this.loading) {
        this.$http.get(this.$config.uri('user/faq')).then((r) => {
          this.allFaq = (r.data.status === 200) ? r.data.data : [];
        });
        this.$http.get(this.$config.uri('user/faq')).then((r) => {
          this.loading = false;
          this.faq = (r.data.status === 200) ? r.data.data : [];
        });
      }
    },
    close(b, d) {
      this.show = false;
    },
    search() {
      if (!this.q || this.q.trim() === '') {
        this.faq = this.allFaq;
      } else {
        this.faq = this.allFaq.filter(o => o.a.toLowerCase().includes(this.q.toLowerCase())
          || o.q.toLowerCase().includes(this.q.toLowerCase()));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 0;
  @media (max-width: 680px) {
    padding: 20px 10px;
  }
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: absolute;
    z-index: 2;
    background-color: #ffe7ea;
    margin: auto;
    overflow: hidden;
    transition: all .3s ease;
    top: 0; right: 0; bottom: 0;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      z-index: 9;
      right: 10px;
      top: 10px;
      background-color: #ffe7ea;
      cursor: pointer;
      transition: all .2s linear;
      opacity: .8;
      @media (max-width: 680px) {
        top: 22px;
        opacity: 1;
        background-color: #fff;
      }
    }
    .close:hover{
      opacity: 1;
    }
    .content{
      width: 640px;
      padding: 40px 80px;
      box-sizing: border-box;
      @media (max-width: 680px) {
        width: 96vw;
        padding: 20px 40px;
      }
      .loadingFaq{
        position: absolute;
        z-index: 9;
        top: 100px; bottom: 40px; left: 0; right: 0;
        border-top: rgba(0,0,0,.1) 1px solid;
        background-size: 46px auto;
        background-position: center;
        background-image: url(../assets/loading.svg);
        background-repeat: no-repeat;
      }
      .searchCnt{
        position: relative;
        z-index: 9;
        @media (max-width: 680px) {
          margin-right: 16px;
          margin-bottom: 10px;
        }
        .searchIcon{
          position: absolute;
          width: 30px; height: 30px;
          right: 10px; top: 5px;
          background-image: url(../assets/search.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .5;
        }
        input{
          font-size: 18px;
          font-weight: normal;
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          width: 100%;
          margin: 0;
          box-sizing: border-box;
        }
      }
      .faqCnt{
        overflow: auto;
        position: absolute;
        z-index: 9;
        top: 100px; bottom: 0; left: 0; right: 0;
        border-top: rgba(0,0,0,.1) 1px solid;
        padding: 30px 80px 0;
        @media (max-width: 680px) {
          padding: 30px 40px;
          top: 80px;
        }
        .faqItem{
          margin-bottom: 40px;
          h4{
            margin: 0;
            font-size: 20px;
          }
          p{
            margin: 0;
            font-size: 15px;
            font-weight: normal;
          }
        }
      }
    }
  }
}


.leafL{
  width: 280px; height: 280px;
  position: absolute;
  left: -100px; top: -96px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 8;
  @media (max-width: 680px) {
    width: 240px; height: 240px;
  }
}
.leafR{
  width: 280px; height: 280px;
  position: absolute;
  right: -100px; top: -96px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 8;
  @media (max-width: 680px) {
    width: 240px; height: 240px;
  }
}
.rumputL{
  width: 160px; height: 300px;
  position: absolute;
  left: -60px; bottom: -140px;
  background-image: url(../assets/rumput-l.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
  @media (max-width: 680px) {
    width: 100px;
  }
}
.rumputR{
  width: 160px; height: 300px;
  position: absolute;
  right: -60px; bottom: -180px;
  background-image: url(../assets/rumput-r.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
  @media (max-width: 680px) {
    width: 120px;
  }
}
.payungB{
  width: 180px; height: 180px;
  position: absolute;
  left: 220px; bottom: -140px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
}
.ball{
  width: 80px; height: 80px;
  position: absolute;
  right: -40px; top: 50%;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
}
.tideBg{
  background-image: url(../assets/tide-bg.png);
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0; right: 0; top: 0;
  height: 150px;
  z-index: 1;
}

</style>
